import Vue from 'vue';

export let eventBus = new Vue();